import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { request as defaultRequest } from "@octokit/request";
import { oauthRequest } from "./utils";

function exchangeDeviceCode(_x) {
  return _exchangeDeviceCode.apply(this, arguments);
}

function _exchangeDeviceCode() {
  _exchangeDeviceCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(options) {
    var request, response, authentication, apiTimeInMs;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            request = options.request ||
            /* istanbul ignore next: we always pass a custom request in tests */
            defaultRequest;
            _context.next = 3;
            return oauthRequest(request, "POST /login/oauth/access_token", {
              client_id: options.clientId,
              device_code: options.code,
              grant_type: "urn:ietf:params:oauth:grant-type:device_code"
            });

          case 3:
            response = _context.sent;
            authentication = {
              clientType: options.clientType,
              clientId: options.clientId,
              token: response.data.access_token,
              scopes: response.data.scope.split(/\s+/).filter(Boolean)
            };

            if ("clientSecret" in options) {
              authentication.clientSecret = options.clientSecret;
            }

            if (options.clientType === "github-app") {
              if ("refresh_token" in response.data) {
                apiTimeInMs = new Date(response.headers.date).getTime();
                authentication.refreshToken = response.data.refresh_token, authentication.expiresAt = toTimestamp(apiTimeInMs, response.data.expires_in), authentication.refreshTokenExpiresAt = toTimestamp(apiTimeInMs, response.data.refresh_token_expires_in);
              }

              delete authentication.scopes;
            }

            return _context.abrupt("return", _objectSpread(_objectSpread({}, response), {}, {
              authentication: authentication
            }));

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _exchangeDeviceCode.apply(this, arguments);
}

function toTimestamp(apiTimeInMs, expirationInSeconds) {
  return new Date(apiTimeInMs + expirationInSeconds * 1e3).toISOString();
}

export { exchangeDeviceCode };